module.exports = __webpack_public_path__ + "static/media/quotation.12c432dd.png";